// Contract address on the official website

export const USDT_ADDRESS = "";
